import { Component, OnInit, Input } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  FormControl,
  ValidatorFn,
  FormArray,
} from "@angular/forms";
import { Router, ActivatedRoute, provideRoutes } from "@angular/router";
import { WMS } from "src/app/classes/device";
import { DashboardService } from "../dashboard.service";
import { ToastrService } from "ngx-toastr";
import { DatePipe } from "@angular/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MustMatch } from "src/app/data-service/must-match.validator";

@Component({
  selector: "app-add-string-popup",
  templateUrl: "./add-string-popup.component.html",
  styleUrls: ["./add-string-popup.component.scss"],
})
export class AddStringPopupComponent implements OnInit {
  private ResponseVerifiedInverterList: Subject<any> = new Subject();
  @Input() type: String;
  @Input() userId: any;
  inverterList: any = [];
  wmsInfo = new WMS();
  pipe = new DatePipe("en-US");
  addStringPopup: FormGroup;
  message: string;
  DeviceList: any;
  deviceId: any;
  role: any;
  roleName: string;
  mpptArray: any;
  stringArray: any;
  selectedInv: any;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private dashbord: DashboardService,
    private toastr: ToastrService
  ) {
    this.role = localStorage.role;
    if (this.role == "1") {
      this.roleName = "admin";
    } else if (this.role == "2") {
      this.roleName = "epc";
    }
  }
  ngOnInit() {
    if (this.roleName == "epc") {
      // this.getDeviceList();
    }
    this.addStringPopup = this.fb.group({
      inverterId: [null, Validators.compose([Validators.required])],
      strings: this.fb.array([]),
      mppt: this.fb.array([]),
    });
    if (this.type == "normal") {
      this.getNormalInverterList();
    }
  }
  get f() {
    return this.addStringPopup.controls;
  }

  createStrings(stringName, nop = null, status = null): FormGroup {
    return this.fb.group({
      name: [stringName, Validators.required],
      nop: [nop, Validators.required],
      status: [status, Validators.required],
    });
  }

  createMppt(mpptName, nop = null, status = null): FormGroup {
    return this.fb.group({
      name: [mpptName, Validators.required],
      nop: [nop, Validators.required],
      status: [status, Validators.required],
    });
  }

  get strings(): FormArray {
    return <FormArray>this.addStringPopup.get("strings");
  }

  get mppt(): FormArray {
    return <FormArray>this.addStringPopup.get("mppt");
  }

  clearArrayForm() {
    this.strings.clear();
    this.mppt.clear();
  }

  addString(stringName, nop = null, status = null) {
    this.strings.push(this.createStrings(stringName, nop, status));
  }

  addMppt(mpptName, nop = null, status = null) {
    this.mppt.push(this.createMppt(mpptName, nop, status));
  }

  ngOnDestroy() {}
  changeTime(e) {}

  public getNormalInverterList() {
    this.dashbord
      .getInverterListAdmin({ userId: this.userId })
      .pipe(takeUntil(this.ResponseVerifiedInverterList))
      .subscribe(
        async (result) => {
          if (result.status) {
            for (let index = 0; index < result.resultObject.length; index++) {
              if (
                result.resultObject[index]["sub_device_type_id"] == "1" ||
                result.resultObject[index]["sub_device_type_id"] == 1
              ) {
                this.inverterList.push(result.resultObject[index]);
              }
            }
          } else if (!result.status) {
            if (result.message === "Unauthorised or Login Time-out") {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(result.message);
            }
          }
        },
        (err) => {
          return console.error(err);
        }
      );
  }

  private getMpptStringData(params) {
    this.clearArrayForm();
    this.dashbord.getMpptDataAdmin(params).subscribe(
      async (result) => {
        if (result.status) {
          if (
            result.resultObject &&
            typeof result.resultObject[0] !== "undefined" &&
            result.resultObject[0].String
          ) {
            if (result.resultObject[0].String.length > 0) {
              result.resultObject[0].String.forEach((ele) => {
                this.addString(ele.string,ele.nop,ele.status=='t'?true:false);
              });
            }
          }
          if (
            result.resultObject &&
            typeof result.resultObject[0] !== "undefined" &&
            result.resultObject[0].mppt
          ) {
            if (result.resultObject[0].mppt.length > 0) {
              result.resultObject[0].mppt.forEach((ele) => {
                this.addMppt(ele.mppt,ele.nop,ele.status=='t'?true:false);
              });
            }
          }
        } else if (!result.status) {
        }
      },
      (err) => {
        return console.error(err);
      }
    );
  }

  onInverterChange(eventValue) {
    const selectedInverter = this.inverterList.filter(
      (res) => res.id == eventValue
    )[0];
    this.selectedInv = selectedInverter;
    const postJson = {
      userId: selectedInverter.user_id,
      sub_device_id: selectedInverter.sub_device_id,
      inv_id: selectedInverter.id,
    };
    this.getMpptStringData(postJson);
  }

  saveNop() {
    const postJson = {
      userId: this.selectedInv.user_id,
      sub_device_id: this.selectedInv.sub_device_id,
      inv_id: this.selectedInv.id,
      strings: this.addStringPopup.value.strings,
      mppt: this.addStringPopup.value.mppt,
    };
    this.dashbord.saveMpptAndStringNop(postJson).subscribe(
      (res) => {
        if(res.status){
          this.toastr.success("Your data has been saved successfully!");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
